import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { useLabels } from 'wsm-common-data';
import { DIRECTION } from '../../global-constants';

const NavigatorButton = ({
	handleNavigator,
	direction,
	className,
	disabled
}) => {
	const labels = useLabels();
	const isRightNavigator = direction === DIRECTION.RIGHT;
	const navigatorTitle = isRightNavigator
		? labels.get('VIEW_NEXT_VEHICLE')
		: labels.get('VIEW_PREVIOUS_VEHICLE');

	return (
		<div className={`navigator-${direction} d-inline`}>
			<button
				className={setClassNames([
					className,
					'btn btn-carousel',
					'navigator p-0',
					disabled && 'disabled'
				])}
				type="button"
				aria-disabled={disabled}
				aria-label={navigatorTitle}
				onClick={(e) => handleNavigator(e, direction)}
				title={navigatorTitle}
			>
				<i
					className={`ddc-icon ddc-icon-carousel-arrow ddc-icon-carousel-arrow-${direction} d-block pointer-events-none`}
					aria-hidden="true"
					data-testid="navigator-icon"
				/>
			</button>
		</div>
	);
};

NavigatorButton.propTypes = {
	handleNavigator: PropTypes.func.isRequired,
	direction: PropTypes.string.isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool
};

export default NavigatorButton;
